import { FieldSwitch, FlexBox, Text } from '@dixa/lib-shared-habla';
import { ChangeEvent, ComponentProps, useCallback, useMemo } from 'react';

import { useServerStorage } from 'utils/useServerStorage';

import styles from './toggleEmailAutofillForm.module.scss';

export const ToggleEmailAutofillFrom = (): JSX.Element | null => {
  const { data, set } = useServerStorage('organization');

  const checked: boolean =
    data.autofill_email_from === undefined || data.autofill_email_from === true;

  const onChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      set({ autofill_email_from: () => event.target.checked });
    },
    [set],
  );

  const input = useMemo<ComponentProps<typeof FieldSwitch>['input']>(
    () => ({
      name: 'autofill_email_from',
      value: 'autofill_email_from',
      onChange,
      checked,
    }),
    [checked, onChange],
  );

  return (
    <FlexBox alignItems="center" gap="300" className={styles.toggleBox}>
      <FlexBox flex="1" flexDirection="column" gap="200">
        <Text.Paragraph variant="1">
          Auto-fill the sender (From:) with the last selected value
        </Text.Paragraph>

        <Text.Paragraph variant="2">
          Apply to all agents but only for new outbound emails, not when
          replying in existing conversations. Each agent will have the last
          value they selected.
        </Text.Paragraph>
      </FlexBox>
      <FlexBox flex="0">
        <FieldSwitch input={input} />
      </FlexBox>
    </FlexBox>
  );
};
